export const FNB_TYPE_FOOD = "food";
export const FNB_TYPE_DRINK = "drink";
export const DEFAULT_FNB_OPTION_VALUES = ["0", "25", "50", "75", "100"];

export const isFnbBusinessType = (businessType = "") => {
  const normalized = String(businessType || "").trim().toLowerCase();
  return normalized === "cafe" || normalized === "restaurant";
};

export const getDefaultFnbType = (businessType = "") => {
  const normalized = String(businessType || "").trim().toLowerCase();
  if (normalized === "cafe") return FNB_TYPE_DRINK;
  if (normalized === "restaurant") return FNB_TYPE_FOOD;
  return null;
};

export const ensureDrinkOptionValues = (values = []) => {
  const normalizedValues = Array.isArray(values)
    ? values
        .map((option) =>
          option && typeof option === "object" ? option.value ?? option.name : option,
        )
        .filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
        .map((value) => String(value))
    : [];
  return normalizedValues.length ? normalizedValues : [...DEFAULT_FNB_OPTION_VALUES];
};

export const getFnbFormDefaults = (businessType = "") => ({
  fnb_type: getDefaultFnbType(businessType),
  ice: [...DEFAULT_FNB_OPTION_VALUES],
  sugar: [...DEFAULT_FNB_OPTION_VALUES],
});

export const normalizeFnbPayloadOptions = ({ fnbType, ice, sugar }) => {
  if (fnbType === FNB_TYPE_FOOD) {
    return { ice: [], sugar: [] };
  }

  return {
    ice: Array.isArray(ice) ? ice : [],
    sugar: Array.isArray(sugar) ? sugar : [],
  };
};

